<template>
  <div>

 <ul id="chat"    v-if="Choosen.hasOwnProperty('discussion')">
       <div v-for="item in Choosen.discussion" :key="item.name">
<li class="you" v-if="item.memberId==id">
<div class="entete" >
                  <span class="status green"></span>
          <h2>{{locfun.getName(item.memberId,teachernameandId,membernameandId) }}</h2>
          <h3>{{locfun.getDate(item.time) }}</h3>
        </div>
        <div class="triangle"></div>
        <div class="message">
         {{ item.comment }}
        </div>
      </li>
       <li class="me" v-else>
        <div class="entete">
          <h3>{{locfun.getDate(item.time) }}</h3>
          <h2>{{locfun.getName(item.memberId,teachernameandId,membernameandId) }}</h2>
          <span class="status" :class="colors[membernameandId.findIndex(id => id[1] === item.memberId )]"></span>
        </div>
        <!-- <div class="triangle"></div> -->
        <div class="message" :class="colors[membernameandId.findIndex(id => id[1]  === item.memberId )]" >
           {{ item.comment }}
        </div>
      </li>
</div>
    </ul>
    <v-text-field
      label="Ny kommentar"
      hint="Skriv en kommentar gällande ärendet."
      v-model="newComment.comment"
      :append-outer-icon="newComment.comment ? 'send' : ''"
      filled
      clear-icon="clear"
      clearable
      type="text"
      @click:append-outer="sendMessage()"
      @click:clear="newComment.comment = ''"
    ></v-text-field>
  </div>
</template>
<script>
// let fun = require("./functions");
import fun from "../functions";
import { mapActions } from "vuex";
export default {
    name:"Discuss",
    created(){
        this.locfun= new fun();
    },
    props:{
        Choosen: Object,
        teachernameandId: Array,
        membernameandId: Array,
        id: String,
    },
data() {
    return {
      newComment: {memberId:this.id, comment:""},
      locfun: null,
      colors:["orange","red","blue","pink","purple"]
    };
  },
  methods: {
    ...mapActions(['showSuccessSnackbar']),
         ...mapActions("cases", [
      ,"UpdateCase" 
    ]),
sendMessage(){
            if (this.Choosen.hasOwnProperty('discussion')==false) {
                this.Choosen.discussion=[]
            }
            this.newComment.time= Date.now();
            
            this.Choosen.discussion.push(this.newComment);
            this.UpdateCase([this.Choosen])
            this.newComment= {memberId:this.id, comment:""}
            
      this.showSuccessSnackbar("Din kommentar är skickad")
},
  },
}
</script>
<style >


.status{
  width:8px;
  height:8px;
  border-radius:50%;
  display:inline-block;
  margin-right:7px;
}
.green{
  background-color:#58b666;
}
.orange{
  background-color:#ff725d;
}
.green{
  background-color:#58b666;
}
.red{
  background-color:red;
}
.pink{
  background-color:pink;
}
.purple{
  background-color:purple;
}
.blue{
  background-color:#6fbced;
}


#chat{
  padding-left:0;
  margin:0;
  list-style-type:none;
  overflow-y:scroll;
  height:535px;
  border-top:2px solid #fff;
  border-bottom:2px solid #fff;
}
#chat li{
  padding:10px 30px;
}
#chat h2,#chat h3{
  display:inline-block;
  font-size:13px;
  font-weight:normal;
}
#chat h3{
  color:#bbb;
}
#chat .entete{
  margin-bottom:5px;
}
#chat .message{
  padding:20px;
  color:#fff;
  line-height:25px;
  max-width:90%;
  display:inline-block;
  text-align:left;
  border-radius:5px;
}
#chat .me{
  text-align:right;
}
#chat .you .message{
  background-color:#58b666;
}
#chat .you .message{
  background-color:#58b666;
}
#chat .me .message{
  background-color:#6fbced;
}
#chat .triangle{
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
}
#chat .you .triangle{
    border-color: transparent transparent #58b666 transparent;
    margin-left:15px;
}
#chat .me .triangle{
    border-color: transparent transparent #6fbced transparent;
    margin-left:375px;
}


</style>